import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "VolumeLow.svg",
  "use": "VolumeLow.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"VolumeLow.svg\"><path d=\"M8.0111,26.0283a3.0009,3.0009,0,0,1,3.0015-3h5.5a4.0035,4.0035,0,0,0,2.829-1.1707l8.252-8.2427A2.0014,2.0014,0,0,1,31.01,15.03V49.02a2.0019,2.0019,0,0,1-3.4168,1.4155l-8.2442-8.2345A4.0024,4.0024,0,0,0,16.52,41.03H11.0126a3.0008,3.0008,0,0,1-3.0015-3Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol